import { cn } from "@/lib/utils";

interface BrandMarkProps {
  name: string;
  logoUrl: string | null;
  className?: string;
}

function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length > 1) return `${words[0][0]}${words[1][0]}`.toUpperCase();
  return name.trim().slice(0, 2).toUpperCase();
}

/** Tenant-neutral visual mark. A missing logo deliberately renders initials. */
export function BrandMark({ name, logoUrl, className }: BrandMarkProps) {
  if (logoUrl) {
    return <img src={logoUrl} alt={`${name} logo`} className={cn("object-contain", className)} />;
  }

  return (
    <span
      role="img"
      aria-label={`${name} logo`}
      className={cn("grid place-items-center font-semibold", className)}
    >
      {initials(name)}
    </span>
  );
}
